module.exports = () => {
  return {
    /** 定向包名称 */
    name: {
      label: '定向包名称',
      type: 'input',
      props: {
        placeholder: '请输入定向包名称',
      },
      value: '',
    },
  };
};
